// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"433":"8f80ad47e1656554","775":"3a2186d00b55d434"}[chunkId] + ".js";
};